import React from 'react'
import { useMemo } from 'sb-hooks'
import { array } from 'common/helpers'

import { Box, Skeleton } from 'components/_new/layout'
import Row from 'components/_new/layout/Row/Row'

import Product, { ProductProps } from './Product/Product'

import s from './ProductList.scss'


export type ProductListProps = {
  items: ProductProps[]
  isFetching: boolean
}

const ProductList: React.FunctionComponent<ProductListProps> = ({ items, isFetching }) => {
  const products = useMemo(() => {
    if (isFetching) {
      // show skeleton if it's fetching
      return array.range(1, 3).map((key) => (
        <Skeleton key={key} pw={100} ph={100} circle />
      ))
    }

    if (items && items.length) {
      return items.map((item) => (
        <Product key={item.id} {...item} />
      ))
    }
  }, [ items, isFetching ])

  if (!products) {
    return null
  }

  return (
    <Row className={s.list} justify="start" align="center" dataTestId="skipAMonthProductList">
      {
        products.map((child) => (
          <Box key={child.key} mh={8} className={s.item}>
            {child}
          </Box>
        ))
      }
    </Row>
  )
}


export default ProductList
